import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useState } from 'react';
import { X } from 'lucide-react';

const TALLY_FORM_URL = "https://tally.so/r/XxYvrz";

export default function SchoolPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <main data-testid="school-page">
      {/* Hero */}
      <section className="min-h-[70vh] lg:min-h-[80vh] flex items-center justify-center bg-[#1F2A44] relative overflow-hidden pt-20 lg:pt-0">
        {/* Subtle accent */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#D97904]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D97904]/5 rounded-full blur-3xl" />
        
        <div className="container-peak relative z-10 py-32">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center px-4"
          >
            <span className="section-tag block mb-4 lg:mb-6">School of Shayamal</span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-light leading-[1.1] mb-4 lg:mb-6 text-[#F4F1EC]">
              Become a <em className="not-italic text-[#D97904]">certified coach</em>
            </h1>
            <p className="text-[#F4F1EC]/70 text-base lg:text-lg xl:text-xl mb-8 lg:mb-10 max-w-2xl mx-auto">
              Take your skills and coaching career to the next level
            </p>
            <button
              onClick={() => setIsFormOpen(true)}
              data-testid="school-waitlist-btn"
              className="btn-primary inline-flex items-center justify-center gap-3"
            >
              Join the Waiting List
              <ArrowRight size={16} />
            </button>
          </motion.div>
        </div>
      </section>

      {/* Tally Form Modal */}
      {isFormOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-white w-full max-w-2xl h-[80vh] rounded-none shadow-2xl relative flex flex-col"
          >
            <button
              onClick={() => setIsFormOpen(false)}
              className="absolute top-4 right-4 text-[#5A6B7A] hover:text-[#1F2A44] transition-colors z-10 bg-white rounded-full p-1"
            >
              <X size={24} />
            </button>
            <div className="flex-1 overflow-hidden">
              <iframe
                src={TALLY_FORM_URL}
                width="100%"
                height="100%"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Join the Waiting List"
                style={{ border: 'none' }}
              />
            </div>
          </motion.div>
        </div>
      )}
    </main>
  );
}
